
import { useNavigate } from 'react-router-dom';

export default function RecentDiscussions() {
  const navigate = useNavigate();
  
  const discussions = [
    {
      id: 'disc-1',
      title: 'Tips for beginners starting competitive play',
      author: 'NewbieHelper',
      avatar: 'NH',
      category: 'Training & Coaching',
      replies: 23,
      lastReply: '15 min ago',
      lastUser: 'ProCoach'
    },
    {
      id: 'disc-2',
      title: 'Season 4 Finals - Post Match Discussion',
      author: 'TournamentFan',
      avatar: 'TF',
      category: 'Tournaments',
      replies: 156,
      lastReply: '28 min ago',
      lastUser: 'AnalystPro'
    },
    {
      id: 'disc-3',
      title: 'Best sensitivity settings for FPS games?',
      author: 'SettingsGuru',
      avatar: 'SG',
      category: 'Game Strategy',
      replies: 67,
      lastReply: '45 min ago',
      lastUser: 'AimMaster'
    },
    {
      id: 'disc-4',
      title: 'EU Team looking for 5th member - Must speak English',
      author: 'EUCaptain',
      avatar: 'EC',
      category: 'Team Recruitment',
      replies: 12,
      lastReply: '1 hour ago',
      lastUser: 'PlayerX'
    },
    {
      id: 'disc-5',
      title: 'Share your craziest comeback moments!',
      author: 'StoryTeller',
      avatar: 'ST',
      category: 'General Discussion',
      replies: 89,
      lastReply: '1 hour ago',
      lastUser: 'ClutchKing'
    },
    {
      id: 'disc-6',
      title: 'How to deal with toxic teammates?',
      author: 'PeaceMaker',
      avatar: 'PM',
      category: 'General Discussion',
      replies: 134,
      lastReply: '2 hours ago',
      lastUser: 'MentalCoach'
    },
    {
      id: 'disc-7',
      title: 'Upcoming patch notes discussion',
      author: 'GameNews',
      avatar: 'GN',
      category: 'Game Strategy',
      replies: 201,
      lastReply: '2 hours ago',
      lastUser: 'MetaAnalyst'
    },
    {
      id: 'disc-8',
      title: 'Free coaching sessions this weekend!',
      author: 'CoachVolunteer',
      avatar: 'CV',
      category: 'Training & Coaching',
      replies: 45,
      lastReply: '3 hours ago',
      lastUser: 'ThankfulPlayer'
    }
  ];

  const handleDiscussionClick = (discussionId: string) => {
    navigate(`/forums/topic/${discussionId}`);
  };

  return (
    <section className="py-20 bg-gray-950">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="text-3xl font-bold text-white mb-2">Recent Discussions</h2>
            <p className="text-gray-400">Latest activity from the community</p>
          </div>
          <div className="flex gap-3">
            <button className="bg-gray-800 hover:bg-gray-700 text-white px-4 py-2.5 rounded-lg font-semibold transition-colors cursor-pointer whitespace-nowrap">
              <i className="ri-filter-3-line mr-2"></i>
              Filter
            </button>
            <button className="bg-teal-600 hover:bg-teal-700 text-white px-4 py-2.5 rounded-lg font-semibold transition-colors cursor-pointer whitespace-nowrap">
              <i className="ri-refresh-line mr-2"></i>
              Refresh
            </button>
          </div>
        </div>

        <div className="bg-gray-900 border border-gray-800 rounded-xl overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-gray-950 border-b border-gray-800">
                <tr>
                  <th className="text-left px-6 py-4 text-sm font-semibold text-gray-400">Topic</th>
                  <th className="text-left px-6 py-4 text-sm font-semibold text-gray-400">Category</th>
                  <th className="text-center px-6 py-4 text-sm font-semibold text-gray-400">Replies</th>
                  <th className="text-left px-6 py-4 text-sm font-semibold text-gray-400">Last Reply</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-800">
                {discussions.map((discussion) => (
                  <tr 
                    key={discussion.id} 
                    onClick={() => handleDiscussionClick(discussion.id)}
                    className="hover:bg-gray-800/50 transition-colors cursor-pointer"
                  >
                    <td className="px-6 py-4">
                      <div className="flex items-center gap-3">
                        <div className="flex-shrink-0 w-10 h-10 flex items-center justify-center bg-teal-500/10 text-teal-400 rounded-lg font-bold text-sm">
                          {discussion.avatar}
                        </div>
                        <div>
                          <h4 className="text-white font-semibold mb-1 hover:text-teal-400 transition-colors">
                            {discussion.title}
                          </h4>
                          <p className="text-gray-500 text-sm">by {discussion.author}</p>
                        </div>
                      </div>
                    </td>
                    <td className="px-6 py-4">
                      <span className="inline-flex items-center gap-1.5 bg-gray-800 text-gray-300 px-3 py-1.5 rounded-full text-sm">
                        <i className="ri-folder-line text-xs"></i>
                        {discussion.category}
                      </span>
                    </td>
                    <td className="px-6 py-4 text-center">
                      <span className="text-teal-400 font-semibold">{discussion.replies}</span>
                    </td>
                    <td className="px-6 py-4">
                      <div className="text-sm">
                        <p className="text-gray-400 mb-1">{discussion.lastReply}</p>
                        <p className="text-gray-500">by {discussion.lastUser}</p>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className="flex justify-center mt-8">
          <div className="flex items-center gap-2">
            <button className="w-10 h-10 flex items-center justify-center bg-gray-800 hover:bg-gray-700 text-white rounded-lg transition-colors cursor-pointer">
              <i className="ri-arrow-left-s-line"></i>
            </button>
            <button className="w-10 h-10 flex items-center justify-center bg-teal-600 text-white rounded-lg font-semibold cursor-pointer">
              1
            </button>
            <button className="w-10 h-10 flex items-center justify-center bg-gray-800 hover:bg-gray-700 text-white rounded-lg transition-colors cursor-pointer">
              2
            </button>
            <button className="w-10 h-10 flex items-center justify-center bg-gray-800 hover:bg-gray-700 text-white rounded-lg transition-colors cursor-pointer">
              3
            </button>
            <span className="px-3 text-gray-500">...</span>
            <button className="w-10 h-10 flex items-center justify-center bg-gray-800 hover:bg-gray-700 text-white rounded-lg transition-colors cursor-pointer">
              12
            </button>
            <button className="w-10 h-10 flex items-center justify-center bg-gray-800 hover:bg-gray-700 text-white rounded-lg transition-colors cursor-pointer">
              <i className="ri-arrow-right-s-line"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
